import {
  tag_colorTagDefaultBackground,
  tag_colorTagDefaultText,
  tag_colorTagPendingBackground,
  tag_colorTagPendingText,
} from 'ext-ui/style/colors'
import { cornerRadius, spacing } from 'ext-ui/style/spacing'
import { css } from 'styled-components'

export const receiptAgentStatusPillContainer = css`
  display: flex;

  & > .Pill[data-design-system-channel='live'] {
    border-radius: ${cornerRadius};
    display: flex;
    flex-grow: 1;
    padding-inline: ${spacing(2)};
  }

  & > .Pill[data-design-system-channel='live'].default:hover {
    background: ${tag_colorTagDefaultBackground};
    color: ${tag_colorTagDefaultText};
  }

  & > .Pill[data-design-system-channel='live'].pending:hover {
    background: ${tag_colorTagPendingBackground};
    color: ${tag_colorTagPendingText};
  }
`
